<template>
    <div v-if="show_intro" class="loading">
        <video autoplay muted loop src="/wp-content/uploads/2019/01/slant-ident-full.mp4"></video>
    </div>
</template>

<script>
export default {
    computed: {
        show_intro() {
            let vm = this;
            return vm.$store.state.show_intro;
        }
    },
    created(){
        let vm = this;
        $('body').addClass('loading');

        setTimeout(function(){
            vm.$store.dispatch( 'updateIntro', false );
            $('body').removeClass('loading');
        }, 2000);
    }
}

</script>